<script lang="ts">
  import { promisePlaceholder } from '#app/lib/promises'
  import type { SerializedItemWithUserData } from '#inventory/lib/items'
  import LandingPageFooter from '#welcome/components/landing_page_footer.svelte'
  import LandingScreen from '#welcome/components/landing_screen.svelte'
  import PublicMap from '#welcome/components/public_map.svelte'
  import SomePublicBooks from '#welcome/components/some_public_books.svelte'

  let items: SerializedItemWithUserData[] = []
  // Give a delay before PublicMap redefines it
  let waitingForItems = promisePlaceholder<void>()
</script>

<div class="welcome-layout">
  <LandingScreen />
  <PublicMap bind:items bind:waitingForItems />
  <SomePublicBooks {items} {waitingForItems} />
  <LandingPageFooter />
  <div class="background-cover"></div>
</div>

<style lang="scss">
  @import "general/scss/utils";
  .welcome-layout{
    :global(h3){
      margin-block-start: 0.5em;
      color: $dark-grey;
    }
  }
  .background-cover{
    @include position(fixed, 0, 0, 0, 0, -10);
    // Photo attribution in https://wiki.inventaire.io/wiki/Credits#Images: Brittany Stevens
    @include multidef-bg-cover("brittanystevens.jpg", "hd");
  }
</style>
